<template>
    <v-container grid-list-md fill-height>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12 md5 class="text-xs-center">
                <v-card style="border-radius: 10px" class="pl-5 pt-3 pb-2 pr-5 elevation-10">
                    <v-card-media src="https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/logo%2FlogoLigabloFood.png?alt=media&token=7f73a57c-db33-472a-9a1f-dccfc96ebb69" height="90px" contain></v-card-media>
                    <v-form class="ma-0" ref="form" v-model="valid" lazy-validation>
                        <v-text-field
                                solo
                                v-model="names"
                                label="Votre prenom et nom"
                                :rules="nameRules"
                                type="text"
                                color="primary"
                        >
                        </v-text-field>
                        <v-text-field
                                solo
                                v-model="email"
                                label="Adresse E-mail"
                                type="email"
                                required
                                :rules="emailRules"
                        >
                        </v-text-field>
                        <v-text-field
                                solo
                                v-model="telephone"
                                label="Numéro de téléphone"
                                type="tel"
                                :rules="phoneRules"
                                color="primary"
                        >
                        </v-text-field>
                        <v-text-field
                                solo
                                v-model="password"
                                label="Mot de passe"
                                type="password"
                                :rules="passwordRules"
                                color="primary"
                        >
                        </v-text-field>
                        <v-btn block dark class="primary" @click="signUp"><b>Inscrir</b></v-btn>
                    </v-form>
                    <p><b>OU</b></p>
                    <v-form>
                        <v-btn block dark class="blue darken-4" @click="signUpWithFacebook"><v-icon left small>fa-facebook</v-icon><b>Connecter avec Facebook</b></v-btn>
                    </v-form>
                </v-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>
<script>
  export default {
    data () {
      return {
        names: '',
        email: '',
        telephone: '',
        password: '',
        emailRules: [
          v => !!v || 'E-mail est requis',
          v => /.+@.+/.test(v) || "L'email doit être valide"
        ],
        passwordRules: [
          v => !!v || 'Mot de passe est requis'
        ],
        nameRules: [
          (v) => !!v || 'Ces noms sont requis',
          (v) => /^[a-zA-Z' a-zA-Z']{2,16}$/.test(v) || 'Les Noms doivent être valides'
        ],
        phoneRules: [
          (v) => !!v || 'Votre tel est requis',
          (v) => /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/.test(v) || 'Le numero doit être valide'
        ]
      }
    },
    methods: {
      signUp () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('SIGNUP_USER',
            {
              names: this.names,
              email: this.email,
              telephone: this.telephone,
              password: this.password,
              photoUrl: null,
              role: 'acheteur'
            })
        }
      },
      signUpWithFacebook () {
        this.$store.dispatch('SIGNUP_FACEBOOK')
      }
    }
  }
</script>
<style scoped>
    .paragraphText{
        font-size: 16px;
    }
    .productNameTextSize{
        font-size: 18px;
    }
    @import "../../../node_modules/font-awesome/css/font-awesome.css";
</style>


// WEBPACK FOOTER //
// src/components/auth/SignUp.vue